import style from "./style.module.css";

const Footer = () => {
    return(
        <div className={style.footerContainer}>
            <h3 className={style.footer}>Copyright © 2021 Kenny Cheng</h3>
        </div>
    )
}

export default Footer;